import React, { Component } from 'react';
class ServicePersonList extends Component {
  constructor() {
    super();
    this.state = {
      all_table_row:[],
    };
  }

componentDidMount(){
  var all_table_row = [];
  var list = this.props.service_person_list;
  var service_person = [];
  for(var i=0;i<list.length;i++){
    var id = list[i]['id'];
    var full_name = list[i]['first_name']+" "+list[i]['last_name'];
    service_person.push(
      <option value={id}>{full_name}</option>
    );
  }
  var loaction_id = this.props.loaction_id;
  var icon = '';
  //if(loaction_id>0){
    icon = <i class="fas fa-trash pointer" onClick={this.props.delete_service_person.bind(this,loaction_id)}></i>;
  //}
  all_table_row.push(
    <tr>
    <th scope="col"><select class="form-control form-select" id={"user_id_"+loaction_id} name={"user_id_"+loaction_id}>{service_person}</select></th>
    <th scope="col"><input type="text" name={"user_type_"+loaction_id} id={"user_type_"+loaction_id} className="form-control"/></th>
    <th scope="col">{icon}</th>
    </tr>
  );
  this.setState({all_table_row});
}


  render() {
    return (
      <>{this.state.all_table_row}</>
    );
  }
}

export default ServicePersonList;
